export { Bell as default } from './Bell';
